import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import { ref } from "vue";
import { useAsyncSpinner } from "@/services/Spinner";
import { useCart } from "@/store/useCart";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductListWrapper',
  setup(__props) {

const favorited = ref<Array<string>>([]);
const isFavorited = (id: string) => {
  return favorited.value.find((x) => x == id);
};
const onFavoriteClick = (id: string) => {
  const val = favorited.value.find((x) => x == id);
  if (val) {
    favorited.value = favorited.value.filter((x) => x != id);
  } else {
    favorited.value.push(id);
  }
};

const cartStore = useCart();

const onCartClick = async (partNo: string, quantity: number): Promise<void> => {
  await useAsyncSpinner(async () => {
    await cartStore.addToCart(partNo, quantity, true);
    if (typeof window !== "undefined" && window.BiTracking) {
      const row = cartStore.rows.find((r) => r.item.partNo === partNo);
      window.BiTracking.addToBasket(partNo, row?.quantity, "", cartStore.id, "");
    }
  });
};

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", {
    isFavorited: isFavorited,
    onFavoriteClick: onFavoriteClick,
    favorited: favorited.value,
    onCartClick: onCartClick,
    hideInitialProducts: false
  })
}
}

})